import { Reveal, MaskedInView } from "../lib/anim";

const TEXTURE_IMG = "https://images.unsplash.com/photo-1765859904394-73fd39f97c41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxnb2xkJTIwbGlxdWlkJTIwdGV4dHVyZSUyMG1hY3JvfGVufDB8fHx8MTc4ODEyNjYzNHww&ixlib=rb-4.1.0&q=85";

const TESTIMONIALS = [
  {
    name: "Maya R.",
    img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=160&h=160&q=80",
    quote: "I didn't realize how much I was rushing through intimacy until I started making it a ritual. Slowing down, breathing and actually paying attention to what I was feeling changed the entire experience.",
  },
  {
    name: "Julian M.",
    img: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=160&h=160&q=80",
    quote: "The biggest surprise wasn't intensity. It was presence. I felt less in my head and much more connected to the moment and to my partner.",
  },
  {
    name: "Sophia L.",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=160&h=160&q=80",
    quote: "It turned an ordinary night into an actual experience. Phones away. Music on. No rushing. We spent more time connecting than we had in a long time.",
  },
  {
    name: "Nicole + Andre",
    img: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?auto=format&fit=crop&w=160&h=160&q=80",
    quote: "We started calling it our Friday-night ritual. What we love most is the intention around it. It gives us an excuse to slow everything down and focus on each other.",
  },
  {
    name: "Daniel K.",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=160&h=160&q=80",
    quote: "As a guy, I didn't expect to care about the ritual part. That's actually what I liked most. Less pressure to perform. More attention to touch, connection and being present.",
  },
  {
    name: "Amara J.",
    img: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=160&h=160&q=80",
    quote: "The packaging feels gorgeous, the whole ritual feels luxurious, and I love the reminder that pleasure doesn't have to be rushed.",
  },
];

const Stars = () => (
  <div className="flex gap-1 text-[#d4af37]" aria-label="Five star rating">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className="text-xs">★</span>
    ))}
  </div>
);

export function GoldenRoot() {
  const placeholders = [
    {
      label: "Directions",
      text: "Spray directly onto the clitoris, inside the vagina or into the anus — or all of the above for the full triple-level experience. Then breathe, slow down, and come back to being fully present.",
      testid: "directions-placeholder",
    },
    {
      label: "Warnings",
      text: "For adults 18+ only. Discontinue use immediately if irritation or discomfort occurs. Avoid contact with eyes. Do not use on broken or irritated skin. Not a contraceptive. Keep out of reach of children. Consult an appropriate healthcare professional regarding pregnancy, breastfeeding, allergies, medications or medical concerns.",
      testid: "warnings-placeholder",
    },
  ];
  return (
    <section data-testid="golden-root-section" className="bg-[#050505] px-6 py-28 sm:py-40">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal className="relative order-2 lg:order-1">
            <div className="relative overflow-hidden border hairline-gold">
              <div className="relative h-[420px] sm:h-[520px] overflow-hidden">
                <img
                  src="/images/bottle.jpg"
                  alt="Close crop of the Pleasure Portal label — a couple embraced beneath a golden moon with hibiscus and crystals"
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover object-[50%_58%] scale-[1.45]"
                  data-testid="golden-root-artwork"
                />
                <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 30%, transparent 30%, rgba(5,5,5,0.85) 90%)" }} />
              </div>
              <p className="border-t hairline-gold bg-black/60 px-5 py-3 text-[10px] uppercase tracking-[0.3em] text-[#f7e7ce]/50 ff-sans">
                The Golden Root — a close crop of the Portal
              </p>
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.4em] text-[#f7e7ce]/50 ff-sans">Chapter 03 — The Botanical</p>
            </Reveal>
            <h2 className="mt-6 ff-serif font-light leading-[0.98] text-[#fdfbf7]">
              <MaskedInView delay={0.1}>
                <span className="block text-[10vw] sm:text-6xl">THE GOLDEN</span>
              </MaskedInView>
              <MaskedInView delay={0.22}>
                <span className="block text-[10vw] sm:text-6xl italic gold-text">ROOT RITUAL</span>
              </MaskedInView>
            </h2>
            <Reveal delay={0.2} className="mt-6">
              <p className="text-[11px] uppercase tracking-[0.35em] gold-text ff-sans font-medium">
                Natural Golden Root
              </p>
            </Reveal>

            <div className="mt-8 space-y-4">
              {placeholders.map((p, i) => (
                <Reveal key={p.label} delay={0.08 + i * 0.06} y={16}>
                  <div data-testid={p.testid} className="ornate-dash bg-white/[0.015] p-5">
                    <p className="text-[10px] uppercase tracking-[0.3em] gold-text ff-sans">{p.label}</p>
                    <p className="mt-2 text-[13px] font-light tracking-wide text-[#f7e7ce]/45 ff-sans">{p.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-[#050505] px-6 py-28 sm:py-40">
      <div className="mx-auto max-w-6xl">
        <div className="text-center">
          <h2 className="ff-serif font-light leading-[0.95] text-[#fdfbf7]">
            <MaskedInView>
              <span className="block text-[11vw] sm:text-6xl">THE PORTAL</span>
            </MaskedInView>
            <MaskedInView delay={0.15}>
              <span className="block text-[11vw] sm:text-6xl italic gold-text">IS OPEN.</span>
            </MaskedInView>
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-6 text-sm font-light text-[#f7e7ce]/70 ff-sans">
              A glimpse at the kind of experiences this ritual was created to invite.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p
              data-testid="verified-purchases-label"
              className="mx-auto mt-6 inline-block border border-[#d4af37]/50 px-5 py-2 text-[10px] uppercase tracking-[0.3em] ff-sans gold-text"
            >
              From Portal Customers
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={0.06 + (i % 3) * 0.1}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="group flex h-full flex-col border hairline-champagne bg-white/[0.02] p-8 transition-all duration-500 hover:border-[#d4af37]/50 hover:bg-white/[0.04]"
              >
                <div className="flex items-center gap-4">
                  <img
                    src={t.img}
                    alt={`${t.name} — Pleasure Portal customer`}
                    loading="lazy"
                    className="h-14 w-14 rounded-full border border-[#d4af37]/50 object-cover"
                    style={{ boxShadow: "0 0 24px rgba(212,175,55,0.25)" }}
                  />
                  <div>
                    <Stars />
                    <figcaption className="mt-1 text-[11px] uppercase tracking-[0.25em] text-[#f7e7ce]/70 ff-sans">
                      {t.name}
                    </figcaption>
                    <p className="mt-0.5 text-[9px] uppercase tracking-[0.2em] ff-sans" style={{ color: "#d4af37" }}>
                      Purchased Buy 2 Get 1 Free
                    </p>
                  </div>
                </div>
                <blockquote className="relative mt-6 flex-1">
                  <span className="ff-serif absolute -left-1 -top-5 text-5xl text-[#d4af37]/25 select-none">“</span>
                  <p className="ff-serif text-lg font-light leading-relaxed text-[#f7e7ce]/85">{t.quote}</p>
                </blockquote>
              </figure>
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
}

export function BigStatement() {
  const more = ["MORE PRESENCE.", "MORE SENSATION.", "MORE CONNECTION.", "MORE YOU."];
  return (
    <section data-testid="big-statement-section" className="bg-[#050505] px-6 py-28 sm:py-44">
      <div className="mx-auto max-w-5xl text-center">
        <h2 className="ff-serif font-light leading-[0.95] text-[#fdfbf7]">
          <MaskedInView>
            <span className="block text-[9vw] sm:text-6xl lg:text-7xl">IT'S NOT ABOUT</span>
          </MaskedInView>
          <MaskedInView delay={0.12}>
            <span className="block text-[9vw] sm:text-6xl lg:text-7xl">DOING MORE.</span>
          </MaskedInView>
          <MaskedInView delay={0.3} className="mt-6">
            <span className="block text-[11vw] sm:text-7xl lg:text-8xl">IT'S ABOUT</span>
          </MaskedInView>
          <MaskedInView delay={0.42}>
            <span className="block text-[11vw] sm:text-7xl lg:text-8xl italic gold-text">FEELING MORE.</span>
          </MaskedInView>
        </h2>

        <div className="mt-16 space-y-2">
          <MaskedInView delay={0.05}>
            <span className="ff-serif block text-2xl sm:text-3xl font-light text-[#f7e7ce]/45 line-through decoration-[#ff007f]/60 decoration-1">LESS RUSHING.</span>
          </MaskedInView>
          <MaskedInView delay={0.12}>
            <span className="ff-serif block text-2xl sm:text-3xl font-light text-[#f7e7ce]/45 line-through decoration-[#ff007f]/60 decoration-1">LESS PERFORMING.</span>
          </MaskedInView>
          {more.map((m, i) => (
            <MaskedInView key={m} delay={0.2 + i * 0.1}>
              <span className="ff-serif block text-3xl sm:text-4xl font-light gold-text">{m}</span>
            </MaskedInView>
          ))}
        </div>
      </div>
    </section>
  );
}
